import axios from "axios";
import { Message } from 'element-ui';
import _ from 'lodash';
import { stackMsg, statusMsg } from "./msg";
import { designPreviewAdapter, isDesignPreview } from "../mock/design-preview";

let baseReqUrl = window.expandUrl('~/');
let designPreview = isDesignPreview();

console.log('[基础请求地址] ' + baseReqUrl);

//请求实例
let http = axios.create({
  baseURL: baseReqUrl,
  withCredentials: true, // `withCredentials` 表示跨域请求时是否需要使用凭证
  ...(designPreview ? { adapter: designPreviewAdapter } : {}),
})

//headers中可选参数 
//showLoading是否显示加载动画和动画延迟时间 | 默认true 支持 100 300 1000
//showError 是否主动弹出错误 | 默认true
//returnData 返回错误之后是否继续返回数据 | 默认false

// 请求拦截器
http.interceptors.request.use(config => {
  //get请求添加时间戳
  if (/get/i.test(config.method)) {
    config.params = config.params || {};
    config.params._t = new Date().getTime(); //添加时间戳
  }

  startAjax(config);

  return config;

}, error => {

  endAjax(error.config);
  //return Promise.reject(error);
  return new Promise(() => { });
});

// 响应拦截器
http.interceptors.response.use(response => {
  endAjax(response.config);

  let data = response.data;

  let { error, Error, Err, errorStack,bc_error, trace } = data;
  let _error = error ? error : Error ? Error : Err ?Err : bc_error; //多种错误参数

  let _errorStack = errorStack ? errorStack : trace; // 多种堆栈参数


  //根据后台返回确定-统一弹出错误（data.error 代表错误） 
  if (_error) {
    //是否要弹出错误 
    if (response.config.headers.showError !== false) {
      // 堆栈信息
      if (_errorStack) {
        let url = response.config.url;
        stackMsg(_error, url, _errorStack);
      } else {
        Message({ type: 'error', duration: 10 * 1000, showClose: true, message: _error });
      }
    }

    //返回错误之后是否继续返回数据
    if (response.config.headers.returnData !== true) {
      // 不返回 中止promise链
      return new Promise(() => { })
    } else {
      return data; //返回数据
    }

  } else {
    //正常返回数据
    return data;
  }

}, error => {
  endAjax(error.config);

  if (!error.response) {
    Message({ type: 'error', duration: 10 * 1000, showClose: true, message: error.message || '网络请求失败' });
    return new Promise(() => { });
  }

  // 处理w2sso
  let { status, data } = error.response;
  if (data.w2sso) {
    const back = window.location.href;
    return window.location.href = data.w2sso + '?back=' + back;
  }

  let url = error.response.config.url;

  statusMsg(status, url, data);
  //return Promise.reject(error);
  return new Promise(() => { });

});






let tasks = [];

function startAjax(config) {
  if (window.$rootVM) window.$rootVM.requestCount++;

  // true 1 100 500
  if (config.headers.showLoading !== false) {
    let delay = config.headers.showLoading || 300;
    let task = config.task = { at: new Date().getTime() + delay, desc: config.headers.desc || 'Loading...' };
    tasks.push(task);
  }
}

function endAjax(config) {
  if (window.$rootVM) window.$rootVM.requestCount--;
  if (config.task) {
    tasks = _.filter(tasks, o => config.task !== o)
  }
}

// 循环 
setInterval(() => {
  let now = new Date().getTime();

  if (window.$rootVM) {
    window.$rootVM.loadingTasks = _.filter(tasks, o => {
      return now >= o.at
    });
  }

}, 100);


export {
  http,
}
